import { loadCustomerEmail, PriceFileRequest } from 'helpers/api';
import M from 'materialize-css';

const state = {
    manufacturers: [],
    customerAccount: ''
};

const AppContainerId = '#price_file';

document.addEventListener('DOMContentLoaded', async () => {
    M.AutoInit();

    const appContainer = document.querySelector(AppContainerId);

    if (!appContainer) {
        return;
    }

    try {
        await Promise.all([
            loadManufacturers(),
            loadCustomerAccount()
        ]);

        renderForm(appContainer);
    } catch (error) {
        console.error('Failed to initialize price-file form:', error);

        M.toast({
            html: 'Unable to load the price-file request form.'
        });
    }
});

async function loadManufacturers() {
    const response = await fetch(
        '/assets/json/manufacturers/price_file_request.json'
    );

    if (!response.ok) {
        throw new Error('Unable to load manufacturers.');
    }

    state.manufacturers = await response.json();
}

async function loadCustomerAccount() {
    const response = await loadCustomerEmail();

    state.customerAccount =
        response?.data?.customerAccount || '';
}

function renderForm(container) {
    const form = document.createElement('form');

    form.className = 'email-request-form';
    form.style.maxWidth = '1200px';
    form.style.width = '100%';
    form.style.padding = '20px';

    form.addEventListener('submit', onSendEmail);

    // Heading
    const heading = document.createElement('h5');

    heading.textContent = 'Select Manufacturer(s)';
    heading.style.marginBottom = '10px';
    heading.style.fontSize = '1.50rem';

    // Horizontal line
    const hr = document.createElement('hr');

    hr.style.border = 'none';
    hr.style.borderTop = '1px solid #ccc';
    hr.style.margin = '0 0 20px 0';

    // Manufacturer container
    const manufacturerRow = document.createElement('div');

    manufacturerRow.className = 'manufacturer-row';

    state.manufacturers.forEach((manufacturer, index) => {
        const checkboxId = `mfg_${index}`;

        const column = document.createElement('div');

        column.className = 'col';

        const description =
            manufacturer.description?.trim() || '';

        const descriptionHtml = description
            ? `<span class="manufacturer-desc">
                   (${description})
               </span>`
            : '';

        const manufacturerDisplay = description
            ? `${manufacturer.code} - ${manufacturer.name} (${description})`
            : `${manufacturer.code} - ${manufacturer.name}`;

        column.innerHTML = `
            <label
                for="${checkboxId}"
                style="
                    display:flex;
                    align-items:center;
                    gap:10px;
                    cursor:pointer;
                    width:100%;
                "
            >
                <input
                    type="checkbox"
                    id="${checkboxId}"
                    value="${manufacturerDisplay}"
                    data-manufacturer-id="${manufacturer.manufacturerId}"
                    class="filled-in"
                />

                <span
                    style="
                        display:flex;
                        align-items:center;
                        gap:10px;
                        font-size:1rem;
                    "
                >
                    <img
                        src="${manufacturer.logo}"
                        alt="${manufacturer.name}"
                        class="manufacturer-logo"
                    >

                    <span class="manufacturer-name">
                        ${manufacturer.code} - ${manufacturer.name}
                    </span>

                    ${descriptionHtml}
                </span>
            </label>
        `;

        manufacturerRow.appendChild(column);
    });

    // Required email field
    const emailField = document.createElement('div');

    emailField.className = 'input-field';
    emailField.style.marginTop = '70px';
    emailField.style.marginBottom = '10px';

    emailField.innerHTML = `
    <label
        for="recipient_email"
        style="
            position: static;
            display: block;
            width: 100%;
            text-align: center;
            transform: none;
            color: #000;
            font-size: 1rem;
            margin-bottom: 8px;
        "
    >
        Your Email Address *
    </label>

    <input
        type="email"
        id="recipient_email"
        name="recipient_email"
        autocomplete="email"
        required
    />
`;

    // Submit button
    const buttonWrapper = document.createElement('div');

    buttonWrapper.className = 'btn-primary-center';

    const sendButton = document.createElement('button');

    sendButton.id = 'send_email_btn';
    sendButton.type = 'submit';
    sendButton.className = 'btn waves-effect waves-light blue';

    sendButton.innerHTML = `
    <i class="material-icons" style="font-size:20px;">
        check_circle
    </i>

    <span>Submit</span>
`;

    buttonWrapper.appendChild(sendButton);

    // Assemble form
    container.innerHTML = '';

    form.appendChild(heading);
    form.appendChild(hr);
    form.appendChild(manufacturerRow);
    form.appendChild(emailField);
    form.appendChild(buttonWrapper);

    container.appendChild(form);
}

async function onSendEmail(event) {
    event.preventDefault();

    const selectedCheckboxes = Array.from(
        document.querySelectorAll(
            '#price_file .manufacturer-row input[type="checkbox"]:checked'
        )
    );

    if (selectedCheckboxes.length === 0) {
        M.toast({
            html: 'Please select at least one manufacturer.'
        });

        return;
    }

    const selectedManufacturers = selectedCheckboxes.map(
        checkbox => checkbox.value
    );

    const selectedManufacturerIds = selectedCheckboxes.map(checkbox => {
        const index = Number(checkbox.id.replace('mfg_', ''));
        const manufacturer = state.manufacturers[index];

        console.log('Selected manufacturer:', manufacturer);

        return manufacturer.manufacturerId;
    });

    const hasInvalidId = selectedManufacturerIds.some(
        id => !Number.isInteger(id) || id <= 0
    );

    if (hasInvalidId) {
        console.error(
            'Invalid manufacturer IDs:',
            selectedManufacturerIds
        );

        console.error(
            'Current manufacturer JSON:',
            state.manufacturers
        );

        M.toast({
            html: 'One or more selected manufacturers have an invalid ID.'
        });

        return;
    }

    if (hasInvalidId) {
        console.error(
            'Invalid manufacturer IDs:',
            selectedManufacturerIds
        );

        console.error(
            'Loaded manufacturer data:',
            state.manufacturers
        );

        M.toast({
            html: 'One or more selected manufacturers have an invalid ID.'
        });

        return;
    }

    const emailInput = document.querySelector('#recipient_email');
    const recipientEmail = emailInput?.value.trim() || '';

    if (!recipientEmail) {
        M.toast({
            html: 'Email address is required.'
        });

        emailInput?.focus();
        return;
    }

    const emailPattern =
        /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/;

    if (
        !emailInput.checkValidity() ||
        !emailPattern.test(recipientEmail)
    ) {
        M.toast({
            html: 'Please enter a valid email address, such as name@example.com.'
        });

        emailInput.focus();
        return;
    }

    if (!state.customerAccount) {
        M.toast({
            html: 'Unable to identify the customer account.'
        });

        return;
    }

    const postData = {
        CustomerAccount: state.customerAccount,
        CustomerEmail: recipientEmail,
        Manufacturers: selectedManufacturers,
        ManufacturerIds: selectedManufacturerIds
    };

    const sendButton = document.getElementById('send_email_btn');

    try {
        setButtonLoading(sendButton, true);

        const apiResponse = await PriceFileRequest(postData);

        const result = apiResponse?.data ?? apiResponse;

        const scriptStatus =
            result?.status ??
            result?.Status;

        const scriptMessage =
            result?.message ??
            result?.Message;

        const success =
            result?.success ??
            result?.Success ??
            false;

        const partialSuccess =
            result?.partialSuccess ??
            result?.PartialSuccess ??
            false;

        console.log('NetSuite response:', result);

        if (!scriptStatus || !scriptMessage) {
            throw new Error(
                'The server response did not contain status and message.'
            );
        }

        // Disable the completed form.
        selectedCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
            checkbox.disabled = true;
        });

        emailInput.disabled = true;

        // Show the response below the email field.
        // No success/error toast is displayed here.
        showScriptResponse(
            sendButton,
            scriptStatus,
            scriptMessage,
            success || partialSuccess
        );
    } catch (error) {
        console.error('Price-file request failed:', error);

        const errorResult = error?.response?.data;

        const errorStatus =
            errorResult?.status ??
            errorResult?.Status ??
            'ERROR';

        const errorMessage =
            errorResult?.message ??
            errorResult?.Message ??
            error?.message ??
            'The price-file request failed.';

        selectedCheckboxes.forEach(checkbox => {
            checkbox.disabled = true;
        });

        emailInput.disabled = true;

        // Show the error below the email field.
        // No error toast is displayed here.
        showScriptResponse(
            sendButton,
            errorStatus,
            errorMessage,
            false
        );
    }
}

function setButtonLoading(sendButton, isLoading) {
    if (!sendButton) {
        return;
    }

    sendButton.disabled = isLoading;

    sendButton.innerHTML = isLoading
        ? `
            <span>Submitting...</span>
        `
        : `
            <i class="material-icons" style="font-size:20px;">
                check_circle
            </i>

            <span>Submit</span>
        `;
}

function showScriptResponse(
    sendButton,
    status,
    message,
    isSuccess
) {
    if (!sendButton) {
        return;
    }

    const responseContainer = document.createElement('div');

    responseContainer.style.display = 'flex';
    responseContainer.style.flexDirection = 'column';
    responseContainer.style.alignItems = 'center';
    responseContainer.style.gap = '20px';
    responseContainer.style.marginTop = '15px';

    // NetSuite response message
    const messageContainer = document.createElement('div');

    messageContainer.style.display = 'flex';
    messageContainer.style.alignItems = 'center';
    messageContainer.style.justifyContent = 'center';
    messageContainer.style.fontWeight = 'bold';
    messageContainer.style.color = 'white';
    messageContainer.style.backgroundColor = 'black';
    messageContainer.style.padding = '10px';
    messageContainer.style.borderRadius = '5px';
    messageContainer.style.textAlign = 'center';
    messageContainer.style.fontSize = '1rem';

    const icon = document.createElement('i');

    icon.className = 'material-icons';
    icon.textContent = isSuccess
        ? 'check_circle'
        : 'warning';

    icon.style.marginRight = '8px';
    icon.style.color = isSuccess
        ? '#4caf50'
        : '#ff9800';

    const responseText = document.createElement('span');

    // Exact status and message returned by NetSuite.
    responseText.textContent = `${status}: ${message}`;

    messageContainer.appendChild(icon);
    messageContainer.appendChild(responseText);

    // Back button
    const backButton = document.createElement('button');

    backButton.type = 'button';
    backButton.className =
        'btn waves-effect waves-light blue';

    backButton.innerHTML = `
        <i class="material-icons left">arrow_back</i>
        <span>Back to Price File Request</span>
    `;

    backButton.addEventListener('click', () => {
        const appContainer =
            document.querySelector(AppContainerId);

        if (appContainer) {
            renderForm(appContainer);
        }
    });

    responseContainer.appendChild(messageContainer);
    responseContainer.appendChild(backButton);

    sendButton.replaceWith(responseContainer);
}

